import {
  useCallback, useState,
} from 'react';
import { parseUrl } from '~/_shared/utils/url/url.helpers';
import { AppErrorPageInvalidQueryString } from '~/app/pages/errorPage/queryStringMissing/appErrorPageInvalidQueryString.component';
import { SalesforceRegistrationFinishPageComponent } from './salesforceRegistrationFinishPage.component';
import { useSalesforceRegistrationFinish } from './useSalesforceRegistrationFinish.hook';

export const SalesforceRegistrationFinishPageContainer = () => {
  const salesforceRegistrationFinish = useSalesforceRegistrationFinish();

  const [token] = useState<string | null>(() => {
    const fragments = parseUrl(window.location.href).queryParameters;
    return fragments?.token ?? null;
  });

  const onSubmit = useCallback(async (password: string, confirmPassword: string, callbackToSetFormSuccess?: () => void) => {
    if (!token) {
      return;
    }

    const { sf_instance_url } = await salesforceRegistrationFinish.invoke(token, password, confirmPassword);
    callbackToSetFormSuccess?.();
    location.assign(`${sf_instance_url}/lightning/n/Maptive__Onboarding`);
  }, [salesforceRegistrationFinish, token]);

  if (!token) {
    return <AppErrorPageInvalidQueryString />;
  }

  return (
    <SalesforceRegistrationFinishPageComponent
      isLoading={salesforceRegistrationFinish.isLoading}
      passwordError={salesforceRegistrationFinish.error}
      onSubmit={onSubmit}
    />
  );
};
